"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _stitches = require("../../../stitches.config");

var _wizardsSlice = require("../../../store/wizardsSlice");

var _Checkbox = require("../../input/checkbox/Checkbox");

var _ImageOrLottie = _interopRequireDefault(require("../image-or-lottie/ImageOrLottie"));

var _sharedStyles = require("../sharedStyles");

var StyledQuestion = (0, _stitches.styled)('div', {
  textAlign: 'center'
});
var ChoicesContainer = (0, _stitches.styled)('div', {
  display: 'flex',
  flexFlow: 'wrap',
  justifyContent: 'center',
  marginLeft: 'auto',
  marginRight: 'auto',
  marginTop: '10px',
  maxWidth: '100%',
  width: '335px',
  '@tablet': {
    width: '676px'
  }
});
var Choice = (0, _stitches.styled)('div', {
  backgroundColor: '$white',
  border: '1px solid $grey400',
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '10px',
  marginLeft: '10px',
  marginRight: '10px',
  marginTop: '10px',
  padding: '1px',
  position: 'relative',
  textAlign: 'center',
  width: '310px',
  '&:hover': {
    cursor: 'pointer'
  },
  input: {
    left: '10px',
    position: 'absolute',
    top: '10px',
    zIndex: 2,
    // unset sfcc styles
    fontSize: 'unset',
    opacity: 'unset',
    padding: 'unset',
    textIndent: 'unset',
    width: 'unset'
  },
  variants: {
    selected: {
      true: {
        border: '2px solid $secondary',
        padding: '0'
      }
    }
  }
});
var ChoiceTitle = (0, _stitches.styled)('div', {
  fontWeight: '$semiBold',
  position: 'absolute',
  top: '10px'
});
var ImageAndDescriptionWrapper = (0, _stitches.styled)('div', {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: '25px',
  img: {
    flex: '1',
    width: '55%'
  }
});
var DescriptionWrapper = (0, _stitches.styled)('div', {
  fontSize: '$small',
  overflowWrap: 'break-word',
  marginLeft: '10px',
  marginRight: '5px',
  flex: '1',
  textAlign: 'left'
});
var StyledList = (0, _stitches.styled)('ul', {
  listStylePosition: 'outside',
  paddingInlineStart: '10px',
  textAlign: 'left',
  listStyleType: 'disc'
});
/**
 * A question with images on the left and text on the right as selections for answers.
 * Displayed in rows of 1 for mobile and rows of 3 for desktop.
 * This is can be single or multi-select, but defaults to multi-select.
 */

var DetailedImageQuestion = function DetailedImageQuestion(_ref) {
  var answer = _ref.answer,
      answers = _ref.answers,
      choices = _ref.choices,
      id = _ref.id,
      isCheckBox = _ref.isCheckBox,
      isSingleSelect = _ref.isSingleSelect,
      onNext = _ref.onNext,
      subtitle = _ref.subtitle,
      title = _ref.title,
      totalQuestions = _ref.totalQuestions,
      currentStepIndex = _ref.currentStepIndex,
      category = _ref.category,
      quizPercentage = _ref.quizPercentage;
  var dispatch = (0, _reactRedux.useDispatch)();

  var handleAnswerSelect = function handleAnswerSelect(choiceValue) {
    dispatch((0, _wizardsSlice.setAnswer)({
      answer: choiceValue,
      questionPath: id
    }));
  };

  var handleKeyboardEvent = function handleKeyboardEvent(choiceValue, event) {
    if (event.key === 'Enter') {
      handleAnswerSelect(choiceValue);
    }
  };

  var descriptionRenderer = function descriptionRenderer(content) {
    switch (content.nodeType) {
      case 'paragraph':
        return /*#__PURE__*/_react.default.createElement("p", {
          key: content.content[0].value
        }, content.content[0].value);

      case 'unordered-list':
        return /*#__PURE__*/_react.default.createElement(StyledList, {
          key: content.content[0].content[0].content[0].value
        }, content.content.map(function (listItem) {
          return /*#__PURE__*/_react.default.createElement("li", {
            key: listItem.content[0].content[0].value
          }, listItem.content[0].content[0].value);
        }));

      default:
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }
  };

  var isChoiceSelected = function isChoiceSelected(choiceValue) {
    if (isSingleSelect) {
      return answer === choiceValue;
    }

    return answers.includes(choiceValue);
  }; // Hardcode width rules based on # of choices cause we like fun ui/ux patterns.
  // These rules only account for choices.length of 1, 2, 3, and 4.


  var width = '676px';

  if (choices.length === 1) {
    width = '335px';
  } else if (choices.length === 3) {
    width = '1024px';
  }

  return /*#__PURE__*/_react.default.createElement(StyledQuestion, null, /*#__PURE__*/_react.default.createElement(_sharedStyles.Title, null, title), /*#__PURE__*/_react.default.createElement(_sharedStyles.Subtitle, null, subtitle), /*#__PURE__*/_react.default.createElement(ChoicesContainer, {
    css: {
      '@desktop': {
        width: width
      }
    }
  }, choices.map(function (choice) {
    return isCheckBox && /*#__PURE__*/_react.default.createElement(Choice, {
      "aria-checked": isChoiceSelected(choice.value),
      key: choice.value,
      selected: isChoiceSelected(choice.value),
      onClick: function onClick() {
        handleAnswerSelect(choice.value);
      },
      onKeyDown: function onKeyDown(event) {
        handleKeyboardEvent(choice.value, event);
      }
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.StyledCheckbox, {
      "aria-label": choice.title,
      checked: isChoiceSelected(choice.value),
      id: choice.title,
      onChange: function onChange(e) {},
      name: choice.title,
      type: "checkbox"
    }), /*#__PURE__*/_react.default.createElement(ChoiceTitle, null, choice.title), /*#__PURE__*/_react.default.createElement(ImageAndDescriptionWrapper, null, /*#__PURE__*/_react.default.createElement(_ImageOrLottie.default, Object.assign({}, choice.image, {
      css: (0, _objectSpread2.default)({
        flex: '1'
      }, !choice.description && {
        marginTop: '20px',
        marginBottom: '20px'
      })
    })), Boolean(choice.description) && /*#__PURE__*/_react.default.createElement(DescriptionWrapper, null, choice.description.json.content.map(descriptionRenderer))));
  }), choices.map(function (choice) {
    return !isCheckBox && /*#__PURE__*/_react.default.createElement(Choice, {
      "aria-checked": isChoiceSelected(choice.value),
      "aria-label": choice.title,
      key: choice.value,
      role: "radio",
      selected: isChoiceSelected(choice.value),
      tabIndex: 0,
      onClick: function onClick() {
        handleAnswerSelect(choice.value);
      },
      onKeyDown: function onKeyDown(event) {
        handleKeyboardEvent(choice.value, event);
      }
    }, /*#__PURE__*/_react.default.createElement(ChoiceTitle, null, choice.title), /*#__PURE__*/_react.default.createElement(ImageAndDescriptionWrapper, null, /*#__PURE__*/_react.default.createElement(_ImageOrLottie.default, Object.assign({}, choice.image, {
      css: (0, _objectSpread2.default)({
        flex: '1'
      }, !choice.description && {
        marginTop: '20px',
        marginBottom: '20px'
      })
    })), Boolean(choice.description) && /*#__PURE__*/_react.default.createElement(DescriptionWrapper, null, choice.description.json.content.map(descriptionRenderer))));
  })));
};

DetailedImageQuestion.defaultProps = {
  answer: '',
  answers: [],
  category: '',
  currentStepIndex: '',
  facet: '',
  isCheckBox: '',
  isSingleSelect: false,
  onNext: function onNext() {},
  quizPercentage: '',
  subtitle: ''
};
var _default = DetailedImageQuestion;
exports.default = _default;